import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import store from '../store/index'

Vue.use(Vuetify, {
  iconfont: 'mdi'
});
export default new Vuetify({
  icons: {
    iconfont: 'mdi'

  },
  theme: {
    dark: store.getters.isDarkMode
  }
});
